import { useCallback, useEffect, useState } from "react";
import CnpjUtils from "../../../shared/utils/CnpjUtils";
import { throwResponseError } from "../../utils/api-error-utils";
import { getAuthParams } from "../../utils/pacto-rebates-utils";
import { formatClientContractsResponse } from "../utils/dashboard-contract-utils";

export function useDashboardClientContracts(initialContracts = null) {
	const [clientContracts, setClientContracts] = useState(
		() => initialContracts || []
	);

	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	useEffect(() => {
		if (initialContracts === null) {
			return;
		}

		setClientContracts(initialContracts);
		setError(null);
	}, [initialContracts]);

	const fetchClientContracts = useCallback(async document => {
		const cleanDocument = CnpjUtils.cleanAlphanumericCnpj(document || "");

		if (!cleanDocument) {
			const message = "Informe o documento do cliente.";

			setClientContracts([]);
			setError(message);

			return {
				ok: false,
				error: message
			};
		}

		try {
			setLoading(true);
			setError(null);

			const { accessToken, clientId } = getAuthParams();

			const response = await fetch(
				process.env.REACT_APP_ESSILOR_API +
				`pacto-rebates-dashboard/v1/dashboard/clientes/${cleanDocument}/contratos`,
				{
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						"access_token": accessToken,
						"client_id": clientId
					}
				}
			);

			if (!response.ok) {
				await throwResponseError(
					response,
					"Não foi possível carregar os contratos do cliente."
				);
			}

			const data = await response.json();
			const formattedContracts = formatClientContractsResponse(data);

			setClientContracts(formattedContracts);
			setError(null);

			return {
				ok: true,
				clientContracts: formattedContracts
			};
		} catch (requestError) {
			const errorMessage =
				requestError.message ||
				"Não foi possível carregar os contratos do cliente.";

			setClientContracts([]);
			setError(errorMessage);

			return {
				ok: false,
				error: errorMessage
			};
		} finally {
			setLoading(false);
		}
	}, []);

	const clearClientContracts = () => {
		setClientContracts([]);
		setError(null);
	};

	return {
		clientContracts,
		clientContractsLoading: loading,
		clientContractsError: error,
		fetchClientContracts,
		clearClientContracts
	};
}